import { QueryClient } from 'react-query';
import { QueryClient as QueryV5Client } from '@tanstack/react-query';
import { isMaintenanceError } from '@src/store/maintenanceState';
import isBrowser from '../util/isBrowser';

const guardianQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            enabled: isBrowser,
            // Warning: dismounting and remounting components may bypass no retries
            // setting when response is an error (assumes empty cache and "first" load)
            retry: (failureCount, error) => {
                // Never retry against a soft-frozen backend (maintenance mode)
                if (isMaintenanceError(error)) return false;
                if (process.env.NODE_ENV === 'test') return false;
                return failureCount < 4;
            },
            // Exponential backoff
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        },
    },
});

export const guardianQueryV5Client = new QueryV5Client({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => !isMaintenanceError(error) && failureCount < 3,
        },
    },
});

export default guardianQueryClient;
